export default function searchService(
    houseService,
    Log,
    $http,
    API_SERVER,
    DummyApi,
    Users,
    $q
) {
    let fn = this;

    const getUserId = () => {
        return Users.isAuthenticated().then(
            (userId) => {
                return $q.resolve(userId);
            },
            (reject) => {
                let userId = -1;
                return $q.resolve(userId);
            }
        );
    };

    fn.getByActivity = () => {
        return getUserId().then((userId) => {
            return houseService.getSearchResult(userId).then((items) => {
                Log.obj("getByActivity", items);
                return items;
            });
        });
    };

    fn.getByLocation = () => {
        return getUserId().then((userId) => {
            return houseService.getSearchResult(userId).then((items) => {
                Log.obj("getByLocation", items);
                return items;
            });
        });
    };

    fn.getPeriods = () => {
        return getUserId().then((userId) => {
            return houseService.getSearchResult(userId).then((items) => {
                Log.obj("getPeriods", items);
                return items;
            });
        });
    };

    fn.getPeriodsInline = (aOfParentHouseIDs) => {
        if (DummyApi.isEnabled()) {
            return $q.resolve(DummyApi.getPeriodsInline());
        }

        return houseService.getHousesInline(aOfParentHouseIDs).then((items) => {
            Log.obj("getPeriodsInline", items);
            return items;
        });
    };

    fn.getAvailablePeriods = (locationId, activityId, start, end) => {
        // Endpoint:
        // search/avaiable-periods?location_id=123activity_id=456&start="2020-09-30T00:00"&end="2020-09-30T00:00"
        const endpoint = "/search/avaiable-periods?";
        const params =
            "location_id=" +
            locationId +
            "&activity_id=" +
            activityId +
            "&start=" +
            start +
            "&start=" +
            start +
            "&end" +
            end;

        const url = API_SERVER + endpoint + params;

        Log.endpoint(endpoint, url);

        return DummyApi.getAvailablePeriods(); // getSearchResult

        // return $http.get(url).then(function (res) {
        //     return res;
        // });
    };

    // fn.getResources = (resourcenId) => {
    //     // Endpoint:
    //     // search/avaiable-periods?location_id=123activity_id=456&start="2020-09-30T00:00"&end="2020-09-30T00:00"
    //     const endpoint = "/search/resource?";
    //     const params = "location_id=" + locationId;

    //     const url = API_SERVER + endpoint + params;

    //     Log.endpoint(endpoint, url);

    //     return DummyApi.getAvailablePeriods(); // getSearchResult

    //     // return $http.get(url).then(function (res) {
    //     //     return res;
    //     // });
    // };

    return fn;
}
